module.exports = __webpack_public_path__ + "125c27198d74947c1e2edf3fd9b0fda3.png";